import React, { useState, useEffect, useContext } from 'react'
import { Link } from 'react-router-dom'
import { Spinner, Col, Row,Form } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { 
    faWrench,
    faAsterisk,
    faCheck,
    faTimes,
    faClock,
} 
from '@fortawesome/free-solid-svg-icons'
import { Bar } from 'react-chartjs-2';
import { taskDashboard } from '../Network/Dashboard'
import { listRepairType } from '../Network/Repair'
import { NotifyContext } from '../Library/Notify'
import { LanguageContext } from '../Language/LanguageContext'
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import FilterListIcon from '@material-ui/icons/FilterList';
import axios from 'axios';
import DatePicker from "react-datepicker";
import dayjs from 'dayjs'


export default function TaskElectronicSystem(props){
    
    const [isLoading, setLoading] = useState(false)
    const [tasks, setTasks] = useState([])
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.home
    const notifyCx = useContext(NotifyContext)
    //const tasks = props.tasks
    const taskData = [tasks?.create || 0, tasks?.waiting || 0, tasks?.in_progress || 0, tasks?.complete || 0, tasks?.cancel || 0]

    const [checked, setChecked] = React.useState(false);
    const [isFilter, setIsFilter] = React.useState(false);

    const [repairList, setRepairList] = useState([]);
    const [selectRepair, setSelectRepair] = useState(0);
    const [filtertask, setfiltertask] = React.useState([]);
    const [startDate, setStartDate] = React.useState(null); 
    const [endDate, setEndDate] = React.useState(null); 
    const filtertaskData = [filtertask?.create || 0, filtertask?.waiting || 0, filtertask?.in_progress || 0, filtertask?.complete || 0, filtertask.cancel || 0]
    const building_id = localStorage.getItem("building_id");
    const [dataTask, setDataTask] = React.useState([]);
    const [allTask, setAllTask] = React.useState(0);
    const [newTask, setNewTask] = React.useState(0);
    const [inprogressTask, setInprogressTask] = React.useState(0);
    const [waitingTask, setWaitingTask] = React.useState(0);
    const [completeTask, setCompleteTask] = React.useState(0);
    const [cancelTask, setCancelTask] = React.useState(0);
    
    useEffect( async ()=>{
        setLoading(true)
        listRepairType(
            (data)=>{
                setRepairList(data)
            },
            (error)=>{ }
        )

        taskDashboard(null,
            (data)=>{
                setTasks(data)
                setLoading(false)
            },
            (error)=>{
                setLoading(false)
            })
        handlerChangeDate()
        setIsFilter(false)
        setChecked(false)
        setSelectRepair(0)
    },[startDate, endDate])

    const handlerChangeDate = async () =>{
        try{
            
            const formData = new FormData();
            formData.append('building_id', building_id);
            if(startDate == null || endDate == null){
                formData.append('start_date', dayjs().subtract(30,'day').format("YYYY-MM-DD"));
                formData.append('end_date', dayjs().format("YYYY-MM-DD"));
            }else{
                formData.append('start_date', dayjs(startDate).format("YYYY-MM-DD"));
                formData.append('end_date', dayjs(endDate).format("YYYY-MM-DD"));
            }
            const responseData = await axios.post('https://visitor-api.lifelink.co.th:8082/lifelink/api/v1/dashboard', formData, {timeout:500});
            setDataTask(responseData.data)
            let totalNewTask = 0;
            let totalWaitingTask = 0;
            let totalInprogressTask = 0;
            let totalCompleteTask = 0;
            let totalCancelTask = 0;
            responseData.data.filter((v)=>v.label == 'งานใหม่').map((val)=>{
                totalNewTask = val.data.reduce((val,num) => val + num)
            })
            responseData.data.filter((v)=>v.label == 'รอดำเนินการ').map((val)=>{
                totalWaitingTask = val.data.reduce((val,num) => val + num)
            })
            responseData.data.filter((v)=>v.label == 'กำลังดำเนินการ').map((val)=>{
                totalInprogressTask = val.data.reduce((val,num) => val + num)
            })
            responseData.data.filter((v)=>v.label == 'เสร็จสิ้น').map((val)=>{
                totalCompleteTask = val.data.reduce((val,num) => val + num)
            })
            responseData.data.filter((v)=>v.label == 'ยกเลิก').map((val)=>{
                totalCancelTask = val.data.reduce((val,num) => val + num)
            })
            setAllTask(totalNewTask+totalWaitingTask+totalInprogressTask+totalCompleteTask+totalCancelTask)
            setNewTask(totalNewTask)
            setWaitingTask(totalWaitingTask)
            setInprogressTask(totalInprogressTask)
            setCompleteTask(totalCompleteTask)
            setCancelTask(totalCancelTask)
            
        }catch(e){
            console.log(e)
        }
    }

    const setfilterdashboard = (id) =>{
        setLoading(true)
        taskDashboard(id,
            (data)=>{
                setfiltertask(data)
                setChecked(true)
                setIsFilter(true)
                setLoading(false)
            },
            (error)=>{
                notifyCx.showNotify("Something wrong", error.message, 2)
                setLoading(false)
            })
    }

    const data = {
        labels: [lang.created, lang.waiting, lang.in_progress, lang.complete, lang.cancelled],
        datasets: [{
            label:'งานไฟฟ้า',
            data: taskData,
            backgroundColor: [
                '#bc1b1b',
                '#efb729',
                '#3a88bc',
                '#83d03b',
                '#9d9da7',
            ]
        }],
        
    }

    const test_data = {
        labels: ['ไฟฟ้า', 'ระบบประปาและสุขาภิบาล', 'ระบบแอร์และระบายอากาศ', 'ระบบอื่น ๆ'],
        responsive: true,
        offset: true,
        datasets: [{
            label:lang.created,
            data: [10,20,50,90],
            backgroundColor:'#bc1b1b'
        },
        {
            label:lang.waiting,
            data: [20,30,60,100],
            backgroundColor:'#efb729'
        },
        {
            label:lang.in_progress,
            data: [30,40,70,110],
            backgroundColor:'#3a88bc'
        },
        {
            label:lang.complete,
            data: [40,50,80,130],
            backgroundColor:'#83d03b'
        },
        {
            label:lang.cancelled,
            data: [60,50,40,59],
            backgroundColor:'#9d9da7'
        }
    ]
    } 

    const real_data = {
        labels: ['ไฟฟ้า', 'ระบบประปาและสุขาภิบาล', 'ระบบแอร์และระบายอากาศ', 'ระบบอื่น ๆ'],
        responsive: true,
        offset: true,
        datasets: dataTask.map((val)=>{
            return(
                {
                    label:val.label,
                    data:val.data,
                    backgroundColor:val.backgroundColor
                }
            )
        })
    } 

    return(
        <div className="section">
            { isLoading ?
            <div className="loading-section">
                <Spinner 
                variant="primary" 
                animation="border"
                size="sm"
                />
            </div> : null
            }
            <div className="section-title">
                {lang.task}

            </div>
            <div style={{paddingTop:10}}>
            <Row>
                <Col md={6} lg={6}>
                            <Form.Group>
                                <Form.Label>{'วันที่เริ่มต้น'}</Form.Label>
                                <div>
                                <DatePicker 
                                selected={startDate}
                                onChange={(date)=>{
                                    setStartDate(date)
                                }}
                                className="form-control" 
                                dateFormat="d MMMM yyyy"
                                placeholderText={'วันที่เริ่มต้น'}
                                maxDate={new Date()}
                                />
                                </div>
                            </Form.Group>
                </Col>
                <Col md={6} lg={6}>
                            <Form.Group>
                                <Form.Label>{'วันที่สิ้นสุด'}</Form.Label>
                                <div>
                                <DatePicker 
                                selected={endDate}
                                onChange={(date)=>{
                                    setEndDate(date)
                                }}
                                className="form-control" 
                                dateFormat="d MMMM yyyy"
                                placeholderText={'วันที่สิ้นสุด'}
                                maxDate={new Date()}
                                minDate={startDate}
                                />
                                </div>
                            </Form.Group>
                </Col>
            </Row>
            </div>
            <div>
                <div className="chart-container">
                    <Bar data={real_data} 
                    options={{
                        offsetGridLines: true,
                        drawTicks: true,
                        layout: {
                            padding: {
                            right: 10,
                            }
                        },
                        legend: {
                            display: true,
                            position: "right",
                            align: "center",
                            labels: {
                            usePointStyle: true
                            }
                        },
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: {
                            xAxes: [
                            {
                                stacked: true,
                                ticks: {
                                padding: 0
                                },
                                gridLines: {
                                display: false
                                }
                            }
                            ],
                            yAxes: [
                            {
                                stacked: false,
                                gridLines: {
                                drawBorder: false
                                },
                                ticks: {
                                beginAtZero: true,
                                maxTicksLimit: 5,
                                padding: 5,
                                callback(n) {
                                    if (n < 1e3) return n;
                                    if (n >= 1e3) return +(n / 1e3).toFixed(1) + "K";
                                }
                                }
                            }
                            ]
                        },
                        
                    }}
                    
    />
                </div>
                
                <Row style={{justifyContent:'center'}}>
                <>
                <div className = "filterbutton">
                    <Button 
                        className="button"
                        variant="outlined" 
                        color="primary"
                        size="small"    
                        onClick={()=>{
                            setSelectRepair(null)
                            setIsFilter(false)
                            setChecked(true)
                            //setfilterdashboard(item.id)
                        }}
                        style={{ 
                            color: selectRepair === null ? "white" : "#00275e",
                            backgroundColor: selectRepair === null ? "#00275e": "white"
                        }} 
                    >
                            {lang.all}
                    </Button>
                { repairList.map((item, key)=>
                    <Button 
                        key={key}   
                        className="button"
                        variant="outlined" 
                        color="primary"
                        size="small"    
                        onClick={()=>{
                            setSelectRepair(item.id)
                            setfilterdashboard(item.id)
                        }}
                        style={{ 
                            color: selectRepair === item.id ? "white" : "#00275e",
                            backgroundColor: selectRepair === item.id ? "#00275e": "white"
                        }} 
                    >
                            {langCx.code === "th" ? item.name : item.nameEn}
                    </Button>
                )}
                </div>
                </>
                </Row>

                <Row className="stat-container" style={{marginTop:20}}>
                    <Col className="item" xs={4}>
                        <StatItem 
                        title={lang.all_task} 
                        number={ 
                            checked ?
                                isFilter ?
                                filtertaskData.reduce((total, num)=>total+num) :
                                taskData.reduce((total, num)=>total+num) :
                            allTask }
                        icon={faWrench}
                        />
                    </Col>
                    <Col className="item" xs={4}>
                        <StatItem 
                        title={lang.new_task} 
                        number={  
                            isFilter ?
                            filtertask.create || 0 :
                            newTask}
                        icon={faAsterisk}
                        />
                    </Col>
                    <Col className="item" xs={4}>
                        <StatItem
                        title={lang.waiting}
                        number={  
                            isFilter ?
                            filtertask.waiting || 0 :
                            waitingTask}
                        icon={faClock}
                        />
                    </Col>
                    <Col className="item" xs={4}>
                        <StatItem
                        title={lang.in_progress}
                        number={  
                            isFilter ?
                            filtertask.in_progress || 0 :
                            inprogressTask
                         }
                        icon={faClock}
                        />
                    </Col>
                    <Col className="item" xs={4}>
                        <StatItem
                        title={lang.complete}
                        number={ 
                            isFilter ?
                            filtertask.complete || 0 :
                            completeTask }
                        icon={faCheck}
                        />
                    </Col>
                    <Col className="item" xs={4}>
                        <StatItem
                        title={lang.cancelled}
                        number={  
                            isFilter ?
                            filtertask.cancel || 0 :
                            cancelTask}
                        icon={faTimes}
                        />
                    </Col>
                </Row>
                <div style={{marginTop: 20, textAlign: 'center'}}>
                    <Link to="/repair" className="link-section">
                        {lang.see_more_task}
                    </Link>
                </div>
            </div>
        </div>
    )
}

function StatItem({ title, number, icon }){
    return(
        <div>
            <div className="number">
                { number.toLocaleString() }
            </div>
            <div className="title">
                <FontAwesomeIcon icon={icon} style={{marginRight: 5}}/>
                {title}
            </div>
        </div>
    )
}